module.exports = __webpack_public_path__ + "media/components/HowItWorks/components/WeWereFeatured/assets/dwell-2d61230e2c775b0ae8d55fa8530ab688.png";